import log from "loglevel";
import { apiCoreEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

export const getAnalysesService = (request?: t.GetAnalysesRequestType) => {
  log.info("getAnalysesService Request: " + JSON.stringify(request));
  let GET_ANALYSES_API_ENDPOINT: string;
  const accountName =
    request && request.params ? request.params.account_name : undefined;
  if (accountName) {
    log.info(`Filtering on Account: ${accountName}`);
    GET_ANALYSES_API_ENDPOINT = `${apiCoreEndpoint}/account/analysis?account=${accountName}`;
  } else {
    GET_ANALYSES_API_ENDPOINT = `${apiCoreEndpoint}/account/analysis`;
  }
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_ANALYSES_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_ANALYSES_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const getAnalysisService = (request: t.GetAnalysisRequestType) => {
  log.info("getAnalysisService Request: " + JSON.stringify(request));
  let GET_ANALYSIS_API_ENDPOINT = `${apiCoreEndpoint}/account/analysis`;
  const accountName =
    request && request.params ? request.params.account_name : undefined;
  const analysisName =
    request && request.params ? request.params.analysis_name : undefined;
  if (accountName) {
    GET_ANALYSIS_API_ENDPOINT += `?account=${accountName}`;
    if (analysisName) {
      GET_ANALYSIS_API_ENDPOINT += `&analysis=${analysisName}`;
    }
  }
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_ANALYSIS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_ANALYSIS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const addAnalysisService = (request: t.CreateAnalysisRequestType) => {
  log.info("addAnalysisService Request: " + JSON.stringify(request));
  // request.analysis.account_id;
  const ADD_ANALYSIS_API_ENDPOINT = `${apiCoreEndpoint}/account/analysis`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(ADD_ANALYSIS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, ADD_ANALYSIS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const modifyAnalysisService = (request: t.ModifyAnalysisRequestType) => {
  log.info("modifyAnalysisService Request: " + JSON.stringify(request));
  const analysisId = request.id;
  const MODIFY_ANALYSIS_API_ENDPOINT = `${apiCoreEndpoint}/account/analysis/${analysisId}`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(MODIFY_ANALYSIS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, MODIFY_ANALYSIS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const deleteAnalysisService = (request: t.DeleteAnalysisRequestType) => {
  log.info("deleteAnalysisService Request: " + JSON.stringify(request));
  const analysisId = request.id;
  const DELETE_ANALYSIS_API_ENDPOINT = `${apiCoreEndpoint}/account/analysis/${analysisId}`;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(DELETE_ANALYSIS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, DELETE_ANALYSIS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

/* Teams */
export const getAnalysisTeamsByNameService = (
  request: t.GetAnalysisTeamsByNameRequestType
) => {
  log.info("getAnalysisTeamsService Request: " + JSON.stringify(request));
  const account_name = request.params.account_name;
  const analysis_name = request.params.analysis_name;
  const GET_ANALYSIS_TEAMS_API_ENDPOINT = `${apiCoreEndpoint}/account/analysis/team?account=${account_name}&analysis=${analysis_name}`;

  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_ANALYSIS_TEAMS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_ANALYSIS_TEAMS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const addAnalysisTeamService = (
  request: t.AddAnalysisTeamRequestType
) => {
  log.info("addAnalysisTeamService Request: " + JSON.stringify(request));
  const analysisId = request.analysis_id;
  const ADD_ANALYSIS_TEAM_API_ENDPOINT = `${apiCoreEndpoint}/account/analysis/${analysisId}/team`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(ADD_ANALYSIS_TEAM_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, ADD_ANALYSIS_TEAM_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const deleteAnalysisTeamService = (
  request: t.DeleteAnalysisTeamRequestType
) => {
  log.info("deleteAnalysisTeamService Request: " + JSON.stringify(request));
  const analysisTeamId = request.id;
  const DELETE_ANALYSIS_TEAM_API_ENDPOINT = `${apiCoreEndpoint}/account/analysis/team/${analysisTeamId}`;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(DELETE_ANALYSIS_TEAM_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(
        response,
        DELETE_ANALYSIS_TEAM_API_ENDPOINT
      );
    })
    .then((json) => {
      return json;
    });
};
